import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 12000 });

export async function createEnquiry(payload) {
  const { data } = await client.post("/enquiries", payload);
  return data;
}

export async function listEnquiries(params = {}) {
  const { data } = await client.get("/enquiries", { params });
  return data;
}

/**
 * Fire-and-forget logging of a WhatsApp / phone click.
 * Never throws and never blocks navigation.
 */
export function logContactEvent({ channel, number, display, message, label }) {
  const body = {
    channel,
    number: String(number || ""),
    display: display || "",
    message: message || "",
    label: label || "",
    page: typeof window !== "undefined" ? window.location.pathname : "",
  };

  try {
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
      const ok = navigator.sendBeacon(`${API}/events/contact`, blob);
      if (ok) return Promise.resolve();
    }
  } catch (e) {
    /* fall through to axios */
  }

  return client.post("/events/contact", body).catch(() => {});
}

export async function getStats() {
  const { data } = await client.get("/stats");
  return data;
}

export default client;
